"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulerReducer = exports.haulerAction = exports.haulerTypes = void 0;
const hauler_component_1 = __importDefault(require("./sub-components/hauler.component"));
const hauler_types_1 = require("./hauler.types");
Object.defineProperty(exports, "haulerTypes", { enumerable: true, get: function () { return hauler_types_1.haulerTypes; } });
const hauler_action_1 = __importDefault(require("./hauler.action"));
exports.haulerAction = hauler_action_1.default;
const hauler_reducer_1 = __importDefault(require("./hauler.reducer"));
exports.haulerReducer = hauler_reducer_1.default;
exports.default = hauler_component_1.default;
